import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Jobs from "./pages/Jobs";
import TownJobs from "./pages/TownJobs";
import NhsJobs from "./pages/NhsJobs";
import JobDetail from "./pages/JobDetail";
import ExtJobDetail from "./pages/ExtJobDetail";
import CompanyProfile from "./pages/CompanyProfile";
import Pricing from "./pages/Pricing";
import Plans from "./pages/Plans";
import Platform from "./pages/Platform";
import Messages from "./pages/Messages";
import Resources from "./pages/Resources";
import InsightArticle from "./pages/InsightArticle";
import Accessibility from "./pages/Accessibility";
import PostJob from "./pages/PostJob";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Cookies from "./pages/Cookies";
import CookieBanner from "./components/CookieBanner";
import Login from "./pages/Login";
import JoinOffer from "./pages/JoinOffer";
import Courses from "./pages/Courses";
import BookDemo from "./components/BookDemo";
import AuthCallback from "./pages/AuthCallback";
import VerifyEmail from "./pages/VerifyEmail";
import Register from "./pages/Register";
import MfaRecovery from "./pages/MfaRecovery";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import ControlTower from "./pages/ControlTower";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import NotFound from "./pages/NotFound";
import "@/App.css";
import { api } from "./lib/api";
import InterviewRoom from "./pages/InterviewRoom";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function TrackVisit() {
  const { pathname } = useLocation();
  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    api.post("/track/visit", {
      path: pathname,
      utm_source: p.get("utm_source") || "", utm_medium: p.get("utm_medium") || "",
      utm_campaign: p.get("utm_campaign") || "", referer: document.referrer || "",
    }).catch(() => {});
  }, [pathname]);
  useEffect(() => {
    const id = setInterval(() => {
      api.post("/track/ping", { path: window.location.pathname }).catch(() => {});
    }, 30000);
    return () => clearInterval(id);
  }, []);
  return null;
}

function AppShell() {
  const location = useLocation();
  // Google OAuth returns with #session_id=... — handle synchronously before any route renders
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <TrackVisit />
      <BookDemo />
      <Navbar />
      <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/jobs/near/:town" element={<TownJobs />} />
            <Route path="/jobs/nhs" element={<NhsJobs />} />
            <Route path="/jobs/ext/:source/:id" element={<ExtJobDetail />} />
            <Route path="/interviews/:id" element={<InterviewRoom />} />
            <Route path="/jobs/:slug" element={<JobDetail />} />
            <Route path="/companies/:slug" element={<CompanyProfile />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/platform" element={<Platform />} />
            <Route path="/post-a-job" element={<PostJob />} />
            <Route path="/about" element={<Navigate to="/" replace />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/insights/:slug" element={<InsightArticle />} />
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/join/:audience" element={<JoinOffer />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/mfa-recovery" element={<MfaRecovery />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/control-tower" element={<ControlTower />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          <CookieBanner />
          <Toaster position="top-right" richColors />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
